import { TagType } from '../../enums/common/tag-type';
import { TagContent } from './tag-content';

export class Tag {
  public name: string;
  public id?: number;
  public token?: number;
  public createdAt?: Date;
  public updatedAt?: Date;
  public tagType?: TagType;
  public slug?: string;
  public icon?: string;
  public relatedTags?: Tag[];
  public backgroundColor?: string;
  public fontColor?: string;
  public content?: TagContent;
  public subTitle?: string;
  public aboutTitle?: string;
  public isSingleMenu?: boolean;
  public order?: number;
  public showTags?: boolean;
  public hasCertificate?: boolean;
  public hasLanguageFilter?: boolean;
  public keyTranslation?: string;
  public hasSpecialty?: boolean;
}
